import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { catchError, map, Observable, of } from "rxjs";
import { SnackBarService } from "./snack-bar.service";
import { SearchPostalCodeResponseBody } from "./types/search-postal-code-service-response.type";

@Injectable({
  providedIn: "root",
})
export class SearchPostalCodeService {
  private readonly viaCepUrl = "https://viacep.com.br/ws";

  private readonly snackbarService = inject(SnackBarService);
  private readonly http = inject(HttpClient);

  getPostalCode(cep: string): Observable<SearchPostalCodeResponseBody | null> {
    return this.http
      .get<
        SearchPostalCodeResponseBody | { erro: boolean }
      >(`${this.viaCepUrl}/${cep}/json`)
      .pipe(
        map((response) => {
          if (response?.erro) {
            throw new Error("Resposta com erro da API");
          }
          return response;
        }),
        catchError((_error) => {
          this.snackbarService.openSnackBar(
            "Falha ao buscar o endereço com o CEP fornecido",
            "Fechar",
            "error",
          );
          return of(null);
        }),
      );
  }
}
